import { SummaryData } from "./types/summary";

type ExtractSummaryProps = {
  summary: Pick<
    SummaryData,
    | "assetName"
    | "date"
  >;
};

export function ExtractSummary({ summary }: ExtractSummaryProps) {
  const info = [
    { label: "Veículo", value: summary.assetName, icon: "rioglyph-truck" },
    {
      label: "Mês",
      value: summary.date,
      icon: "rioglyph-calendar",
    },
  ];

  return (
    <div style={{display: 'grid', gridTemplateColumns: `repeat(${info.length}, 20%)`}}>
      {info.map(({ label, value, icon }) => (
        <div key={label} className="display-grid gap-5">
          <span className="text-color-dark">{label}</span>
          <span style={{minWidth: 60, overflowWrap: "break-word"}}>
            <span
              className={`rioglyph ${icon} rioglyph-align-baseline text-size-20 text-color-gray`}
            />{" "}
            {value}
          </span>
        </div>
      ))}
    </div>
  );
}
